import { render, staticRenderFns } from "./resultForm.vue?vue&type=template&id=4ea2e364&"
import script from "./resultForm.vue?vue&type=script&lang=js&"
export * from "./resultForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports